import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectedWalletSelector } from '../../../store/wallet/selectors';
import { get } from '../../../lib/api/rest';

export const useTokenAllowance = (tokenAddress: string | null, spenderAddress: string | null, chainId: number) => {
  const { address: userAddress } = useSelector(selectedWalletSelector);

  const {
    data: allowance,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: [
      'tokenAllowance',
      tokenAddress,
      spenderAddress,
      userAddress,
      chainId,
    ],
    queryFn: async () => {
      const res = await get(
        `/api/wallet/${userAddress}/token/${tokenAddress}/approval/${spenderAddress}?chainId=${chainId}`
      ).send();

      if (!res.ok) {
        throw new Error('Failed to fetch token allowance');
      }

      return res.body;
    },
    enabled: !!tokenAddress && !!spenderAddress && !!userAddress && !!chainId,
  });

  return {
    allowance,
    loading: isLoading,
    error: error?.message || null,
    refetch,
  };
};
